import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-main max-w-3xl">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600">关于欧美一区二区平台的常见疑问解答</p>
          </div>
          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div key={idx} className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === idx ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}